<template>
    <header class="header header--4">
        <div class="container">
            <div class="navbar d-none d-lg-flex">
                <main-nav :bookPortal="bookPortal"></main-nav>
                <navbar-logo></navbar-logo>
                <div class="side-menu">
                    <profile-link></profile-link>
                    <login-btn></login-btn>
                </div>
            </div>
            <div class="navbar d-flex d-lg-none">
                <navbar-logo></navbar-logo>
                <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasMenu" aria-controls="offcanvasMenu">Menu</button>
            </div>
            <div class="offcanvas-menu offcanvas offcanvas-end" tabindex="-1" id="offcanvasMenu">
                <div class="offcanvas-menu__header">
                    <h3 class="offcanvas-menu__header_title">Menu</h3>
                    <button type="button" class="btn offcanvas-menu__header_btn" data-bs-dismiss="offcanvas" aria-label="Close">
                        <svg width="48" height="48">
                            <use href="/static/images/sprite/sprite.svg#close"></use>
                        </svg>
                    </button>
                </div>
                <div class="offcanvas-menu__body">
                    <main-nav :bookPortal="bookPortal"></main-nav>
                    <div class="d-flex justify-content-between">
                        <profile-link></profile-link>
                        <login-btn></login-btn>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import NavbarLogo from "./parts/NavbarLogo.vue";
import ProfileLink from "./parts/ProfileLink.vue";
import LoginBtn from "./parts/LoginBtn.vue";
import MainNav from "./parts/MainNav.vue";

export default {
    props: {
        bookPortal: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        NavbarLogo,
        ProfileLink,
        LoginBtn,
        MainNav,
    },
};
</script>

<style lang="scss">
.header--4 {
    &.header {
        position: relative;
        z-index: 1;
        .container {
            max-width: 1680px;
        }
        .navbar {
            padding: 40px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            &__logo {
                width: 60px;
                height: 50px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .menu {
            display: flex;
            gap: 24px;
            &__item {
                @include font(16, 400);
                color: $marshland;
            }
        }
        .side-menu {
            display: flex;
            gap: 12px;
        }
        @media (max-width: $breakpoint-lg) {
            .navbar {
                padding: 16px 0;
                &__logo {
                    width: 44px;
                    height: 36px;
                    position: relative;
                    left: 0;
                    top: 0;
                    transform: none;
                }
            }
            .offcanvas-menu {
                padding: 20px;
                border-left: none;
                &__header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    &_title {
                        font-family: $extra-font;
                        @include font(24, 700);
                        color: $marshland;
                    }
                    &_btn {
                        padding: 0;
                        svg {
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                &__body {
                    .menu {
                        flex-direction: column;
                        padding: 40px 0;
                    }
                    .profile-link {
                        .btn-secondary {
                            border: 2px solid #0F0F0F;
                        }
                    }
                }
            }
        }
    }
}

</style>